import { render } from "./Claim2.vue?vue&type=template&id=26d90ce2&scoped=true"
import script from "./Claim2.vue?vue&type=script&lang=js"
export * from "./Claim2.vue?vue&type=script&lang=js"

import "./Claim2.vue?vue&type=style&index=0&id=26d90ce2&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-26d90ce2"

export default script